<!--
 * @Descripttion: 
 * @version: 1
 * @Author: Saiu
 * @Date: 2019-10-28 21:57:32
 * @LastEditors: 
 * @LastEditTime: 2019-10-28 22:05:19
 -->
<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">{{$t('pages.login.title')}}</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="param.username" :placeholder="$t('pages.login.usernamePlaceholder')">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" :placeholder="$t('pages.login.passwordPlaceholder')" v-model="param.password" @keyup.enter.native="submitForm()">
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">{{$t('pages.login.submit')}}</el-button>
                </div>
                <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
            </el-form>
        </div>
    </div>
</template>

<script>
import { DecPwd } from '../../utils/helper';
import { SignIn, RefreshToken, GetNonce } from '../../api/Auth';
import CryptoJS from 'crypto-js';
export default {
    data: function () {
        return {
            param: {
                username: '',
                password: ''
            },
            rules: {
                username: [{ required: true, message: this.$t('pages.login.rules.usernameRequired'), trigger: 'blur' }],
                password: [{ required: true, message: this.$t('pages.login.rules.passwordRequired'), trigger: 'blur' }]
            }
        };
    },
    methods: {
        async submitForm() {
            // 1) 拿到真正的 nonce
            const data = await GetNonce(this.param.username);
            // 2) 把 nonce 转成 CryptoJS 的 WordArray
            const key = CryptoJS.enc.Utf8.parse(data.data.nonce);
            // 3) HMAC-SHA256
            const hmac = CryptoJS.HmacSHA256(this.param.password, key).toString(CryptoJS.enc.Hex);
            // 3) 提交登录：loginid, salt, pwd（即 hmac）
            // 4) 正常提交
            const res = await SignIn({
                loginid: this.param.username,
                nonce: data.data.nonce,
                expiry: data.data.expiry,
                signature: data.data.signature,
                response: hmac
            });
            console.log(res.data);
            if (res.status === 0) {
                this.$message.success(this.$t('pages.login.success'));
                localStorage.setItem('ms_username', this.param.username);
                localStorage.setItem('ms_userInfo', JSON.stringify(res.data));
                localStorage.setItem('token', res.msg);
                this.$router.push('/');
            } else {
                this.$message.error(res.msg);
            }
        },
        async updateToken() {
            const resRefresh = await RefreshToken();
            if (resRefresh.status === 0) {
                localStorage.setItem('token', resRefresh.msg);
            }
        }
    }
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: 100%;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>
